import {
  FaPenFancy,
  FaAlignLeft,
  FaEdit,
  FaBrain,
  FaGlobe,
  FaFileExport,
} from "react-icons/fa"; // Make sure you're importing these from react-icons

const KeyFeaturesSection = () => {
  const features = [
    {
      icon: FaPenFancy,
      heading: "Content drafting",
      info: "Write essays, reports, and marketing copy effortlessly with our AI document generator.",
    },
    {
      icon: FaAlignLeft,
      heading: "Text formatting",
      info: "Get full formatting control in terms of structuring, capitalization, word length using our AI writing tools.",
    },
    {
      icon: FaEdit,
      heading: "Rewriting & polishing",
      info: "Adjust tone, audience, technical depth, or creativity with the AI writing assistant for documents.",
    },
    {
      icon: FaBrain,
      heading: "Retrieval-Augmented Generation (RAG)",
      info: "Improve accuracy with intelligent context-based writing.",
    },
    {
      icon: FaGlobe,
      heading: "Web search",
      info: "Enrich your writing with up-to-date references from across the web.",
    },
    {
      icon: FaFileExport,
      heading: "Export to edit",
      info: "Export the generated document as a Word document, Google Docs or PDF for final edits.",
    },
  ];

  return (
    <div className="bg-white mb-14 mt-12">
      <div className="flex flex-col items-center justify-center mb-8">
        <h1 className="text-4xl font-bold text-gray-900 z-10">
          Key Features of Our AI
        </h1>
        <h1 className="text-4xl font-bold text-gray-900 z-10">
          Content Creation Platform
        </h1>
      </div>
      <div className="flex justify-center w-full">
        <div className="w-[80%] grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 px-2 py-1">
          {features.map((feature, index) => (
            <div
              key={index}
              className="flex flex-col rounded-md border border-gray-200 p-8"
            >
              <div className="text-3xl mb-4">
                <feature.icon className="text-3xl mb-4 " />
              </div>
              <h3 className="text-lg font-semibold mb-2">{feature.heading}</h3>
              <p className="text-gray-600">{feature.info}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default KeyFeaturesSection;
